import React, { Component } from 'react';
import { WidgetInstance } from 'friendly-challenge';
import { FriendlyCaptchaProps } from './FriendlyCaptcha.props';
import { FriendlyCaptchaState } from './FriendlyCaptcha.state';

class FriendlyCaptcha extends Component<FriendlyCaptchaProps, FriendlyCaptchaState> {
    container: HTMLDivElement | null = null;
    widget: WidgetInstance | null = null;

    doneCallback = (solution: string) => {
        if (this.props.onSolve) {
            this.props.onSolve(solution);
        }
    }

    errorCallback = (err: unknown) => {
        console.log('There was an error when trying to solve the Captcha.');
        console.log(err);
    }

    componentDidMount() {
        if (!this.container) {
            return;
        }
        this.widget = new WidgetInstance(this.container, { 
            startMode: "auto",
            doneCallback: this.doneCallback,
            errorCallback: this.errorCallback 
        });
    }

    componentWillUnmount() {
        if (this.widget) {
            this.widget.reset();
        }
    }

    render() {
        return (
            <>
                {this.props.siteKey && this.props.puzzleEndpoint && <div ref={el => this.container = el} className="frc-captcha" data-sitekey={this.props.siteKey} data-lang="de" data-puzzle-endpoint={this.props.puzzleEndpoint} />}
                {this.props.errorMessage && <div className="form__captcha-error-message">{this.props.errorMessage}</div>}
            </>
        );
    }
}

export default FriendlyCaptcha;